import { defineStore } from 'pinia'
import { decodeJwt } from '@/utils/GeneralsUtils';

export const loginStore = defineStore('main', {
    state: () => {
        let jwt = null;
        let tokenPayload = null;
        const token = localStorage.getItem("JWT");
        if (token) {
            jwt = token
            tokenPayload = decodeJwt(token)
        }
        return {
            jwt,
            tokenPayload
        }
    },
    actions: {
        setJWT (token: string) {
            this.jwt = token;
            this.tokenPayload = decodeJwt(token)
        }
    },
})